<script setup>
/**
 * FormControlPlainText
 * Lightweight presentational row wrapper for read-only values.
 * Inspects global form-size configuration metrics out of state containers,
 * dynamically managing cell spacing metrics for unified administrative grids.
 */
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
})

const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)
const formSmall = computed(() => formStore.value?.formSmall || false)
</script>

<template>
    <p
        class="bg-body-tertiary rounded text-break"
        :class="{ 'px-2 py-1 small': formSmall, 'p-2': !formSmall }"
    >
        <template v-if="value">{{ value }}</template>
        <slot v-else />
    </p>
</template>

<style scoped>
/* Visual Safety Anchor:
    Forces the paragraph block to maintain a uniform structural height
    even if the backing database field value is null or completely blank.
*/
p::after {
    content: " ";
    font-size: 0;
    white-space: pre;
}
</style>